import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row, UncontrolledTooltip } from 'reactstrap'
import RentalDetails from './RentalDetails'
import Loader from '../Loader'
import './RentalTab.css'
import gql from 'graphql-tag'

import LegacyRentalDetail from '../../Drivers/Driver/Detail/DetailsNew/RentalTab/LegacyRentalDetail'
import withApolloClient from '../../withApolloClient'
import moment from 'moment'

const AgreementQuery = gql`query AllRentals($driverId:ID, $carPk:Int, $cursor: String, $first:Int!, $loadDriverDetails: Boolean!, $loadCarDetails: Boolean!) {
    rentals: allRentals(driverId:$driverId, carPk:$carPk, first:$first, after:$cursor, orderBy:["-start_date"]) {
        edges{
            node{
                id
                pk
                stage
                startDate @include(if: $loadDriverDetails)
                endDate @include(if: $loadDriverDetails)
                driver @include(if: $loadDriverDetails) {
                    id
                    name
                }
                car @include(if: $loadCarDetails) {
                    id
                    pk
                    vin
                    year
                    carModel{
                        id
                        pk
                        name
                        make
                    }
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    }
}
`

const LegacyAgreementsQuery = gql`query allLegacyAgreements($driverId:ID!){
    allLegacyAgreements(driverId:$driverId){
        dateAdded
        dateModified
        agreementType
        startDate
        endDate
        vin
        bosCarId
        driverId
        stage
        scheduledDate
        returnReason
        branchId
    }
}
`

class RentalTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeRentalId: this.props.rentals && this.props.rentals && this.props.rentals.edges.length > 0 ? this.props.rentals.edges[0].node.id : null,
            legacyRental: null
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.rentals !== this.props.rentals || (prevProps.activeTab !== this.props.activeTab && this.props.activeTab === "rentals")) && this.props.rentals && this.props.rentals.edges.length > 0) {
            if (this.props.location.search) {
                let queryParams = new URLSearchParams(this.props.location.search)
                let rentalId = this.props.rentals.edges.find(rental => rental.node.id === queryParams.get("agreementId"))
                this.setState({ activeRentalId: rentalId ? rentalId.node.id : this.props.rentals.edges[0].node.id })
            } else {

                this.props.navigate({ hash: this.props.location.hash, search: `agreementId=${this.props.rentals.edges[0].node.id}` })
                this.setState({ activeRentalId: this.props.rentals.edges[0].node.id })
            }
        }
    }
    setRentalId = (id) => {
        const queryString = new URLSearchParams({ "agreementId": id }).toString()

        this.props.navigate({ hash: this.props.location.hash, search: queryString })
        this.setState({ activeRentalId: id, legacyRental: undefined, })
    }
    setLegacyRental = (legacyRental) => {
        if (!legacyRental || !legacyRental.bosCarId || !legacyRental.startDate || !legacyRental.driverId) return
        const queryString = new URLSearchParams().toString()

        this.props.navigate({ hash: this.props.location.hash, search: queryString })
        this.setState({ activeRentalId: undefined, legacyRental: legacyRental })
    }
    render() {
        return (
            <div className="rental-container">
                <Row>
                    <Col className="agreements-list col-2">
                        {this.props.loading ? <Loader /> : <>
                            {
                                this.props.rentals && this.props.rentals.edges && this.props.rentals.edges.length > 0 ?
                                    this.props.rentals.edges.map((rental, i) =>
                                        <div className={"car-agreement" + (this.state.activeRentalId === rental.node.id ? " active" : "")} onClick={() => this.setRentalId(rental.node.id)} key={i}>
                                            <div className={"sidebar-listing-wrapper-icon"}>
                                                {this.props.viewType === "driver" ?
                                                    <i className={rental.node.stage === "_1" ? "fa fa-2x fa-ban" : "fa fa-2x fa-car"}
                                                        style={{ fontSize: "2em", color: rental.node.stage && rental.node.stage === "_1" ? "red" : rental.node.stage === "A_10" ? "green" : "orange" }}
                                                        aria-hidden="true">
                                                    </i> :
                                                    <i className={rental && rental.node && rental.node.stage === "_1" ? "fa fa-2x fa-ban" : "fa fa-2x fa-user"} style={{ color: rental && rental.node && rental.node.stage === "_1" ? "red" : rental && rental.node && rental.node.stage === "A_10" ? "green" : "orange" }} aria-hidden="true"></i>
                                                }&nbsp;
                                            </div>
                                            <div className={"sidebar-listing-wrapper-text"}>
                                                {this.props.viewType === "driver" ?
                                                    <>
                                                        <p>{rental.node && rental.node.car && rental.node.car.year} {rental.node && rental.node.car && rental.node.car.carModel && rental.node.car.carModel.make}  {rental.node && rental.node.car && rental.node.car.carModel && rental.node.car.carModel.name}</p>
                                                        <small>{rental.node && rental.node.car && rental.node.car.pk} - {rental.node && rental.node.car && rental.node.car.vin}</small>
                                                    </> :
                                                    <>
                                                        <p>{rental && rental.node && rental.node.driver ? rental.node.driver.name : "---"}</p>
                                                        <small>{rental.node?.startDate ? moment(rental.node.startDate).tz("America/New_York").format('ll') : "--"} - {rental.node?.endDate ? moment(rental.node.endDate).tz("America/New_York").format('ll') : "--"}</small>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    ) : <p className="text-center no-rentals">No Rentals Found!</p>
                            }
                            <div id="more-agreements">
                                {this.props.rentals && this.props.rentals.pageInfo.hasNextPage && <>
                                    <i className={"fa fa-2x fa-arrow-circle-down"} style={{ color: "#1B4D7E" }} onClick={this.props.loadMoreAgreements} aria-hidden="true" id={"viewMore"}></i>
                                    <UncontrolledTooltip target={"viewMore"} placement={"left"}>View More</UncontrolledTooltip>
                                </>
                                }
                            </div>

                            {this.props.viewType === "driver" && this.props.allLegacyAgreements && this.props.allLegacyAgreements.length > 0 &&
                                <>
                                    <strong className="car-agreement border-top">Legacy Rentals from other platforms</strong>
                                    {
                                        this.props.allLegacyAgreements && this.props.allLegacyAgreements.length > 0 ?
                                            this.props.allLegacyAgreements.map((legacyRental, i) =>
                                                <div className={"car-agreement"} onClick={() => this.setLegacyRental(legacyRental)} key={i}>
                                                    <div className={"sidebar-listing-wrapper-icon"}>
                                                        <i className={legacyRental.stage === "CANCELED" ? "fa fa-2x fa-ban" : "fa fa-2x fa-car"}
                                                            style={{ fontSize: "2em", color: legacyRental.stage && legacyRental.stage === "CANCELED" ? "red" : legacyRental.stage === "ACTIVE" ? "green" : "orange" }}
                                                            aria-hidden="true">
                                                        </i>&nbsp;
                                                    </div>
                                                    <div className={"sidebar-listing-wrapper-text"}>
                                                        <p>
                                                            {legacyRental.bosCarId}
                                                        </p>

                                                        <small>{legacyRental.bosCarId} - {legacyRental.vin}</small>
                                                    </div>
                                                </div>
                                            ) : <p className="text-center no-rentals">No Rentals Found!</p>
                                    }
                                </>
                            }
                        </>}
                    </Col>
                    {this.state.activeRentalId && this.state.activeRentalId !== "" &&
                        <RentalDetails id={this.state.activeRentalId} currentUser={this.props.currentUser} viewType={this.props.viewType} />
                    }
                    {this.state.legacyRental && this.state.legacyRental?.vin && this.state.legacyRental?.bosCarId &&
                        <LegacyRentalDetail
                            vin={this.state.legacyRental?.vin}
                            stage={this.state.legacyRental?.stage}
                            startDate={this.state.legacyRental?.startDate}
                            endDate={this.state.legacyRental?.endDate}
                            agreementType={this.state.legacyRental?.agreementType}
                            branch={this.state.legacyRental?.branchId}
                            bosCarId={this.state.legacyRental?.bosCarId}
                        />
                    }
                    {!this.state.activeRentalId && !this.state.legacyRental && <div className="zero-padding"><p>No Rental Info Found!</p></div>}
                </Row>
            </div >
        )
    }
}

export default graphql(AgreementQuery, {
    skip: ({ driverId, carId }) => !driverId && !carId,
    options: ({ driverId, carId, viewType }) => ({
        variables: {
            driverId: driverId || null,
            carPk: carId || null,
            first: 8,
            loadDriverDetails: viewType === "car" ? true : false,
            loadCarDetails: viewType === "car" ? false : true
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props({ data: { loading, rentals, fetchMore, variables } }) {
        return {
            loading,
            rentals,
            variables,
            loadMoreAgreements: () =>
                fetchMore({
                    query: AgreementQuery,
                    variables: {
                        cursor: rentals.pageInfo.endCursor,
                        ...variables,
                    },
                    updateQuery: (prev, { fetchMoreResult }) => {
                        const newEdges = fetchMoreResult.rentals.edges
                        const pageInfo = fetchMoreResult.rentals.pageInfo
                        return {
                            rentals: {
                                edges: [...prev.rentals.edges, ...newEdges],
                                pageInfo,
                                searchTerm: prev.searchTerm,
                                __typename: prev.rentals.__typename,
                            },
                        }
                    },
                }),
        }
    },
}
)(graphql(LegacyAgreementsQuery,
    {
        skip: ({ driverId }) => !driverId,
        options: ({ driverId }) => ({
            variables: { driverId: driverId },
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }),
        props({ data: { loading, allLegacyAgreements } }) {
            return { loading, allLegacyAgreements }
        },
    }
)(withApolloClient(RentalTab))
)